
const fieldConfig = [
    {
        id: 'personId',
        label: 'Person ID',
        placeholder: 'Enter Person ID',
        type: 'input',
        required: true,
        marginBottom: 10
    },
    {
        id: 'IIN',
        label: 'IIN',
        placeholder: 'Enter IIN',
        type: 'input',
        required: true,
        marginBottom: 10
    },
    {
        id: 'fullName',
        label: 'Full Name',
        placeholder: 'Enter Full Name',
        type: 'input',
        required: true,
        marginBottom: 10
    },
    {
        id: 'phoneNumber',
        label: 'Phone Number',
        placeholder: 'Enter phone number',
        type: 'input',
        required: true,
        marginBottom: 10
    },
    {
        id: 'selectedLanguage',
        label: 'Flow Language',
        type: 'radio',
        options: [
            { value: 'en', label: 'English' },
            { value: 'kk', label: 'Қазақ тілі' },
            { value: 'ru', label: 'Русский язык' }
        ],
        marginBottom: 10
    },
    {
        id: 'flowLogo',
        label: 'Logo',
        placeholder: 'Please type URL of your image',
        type: 'input',
        required: false,
        marginBottom: 10
    }
];

export default fieldConfig;